import { render } from "./BloqueraView.vue?vue&type=template&id=179ca2b0"
import script from "./BloqueraView.vue?vue&type=script&lang=js"
export * from "./BloqueraView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__